import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AUDIT_ACTION_OPTIONS, AUDIT_ENTITY_OPTIONS } from "../constants";
import { AuditFilters as Filters } from "../hooks/use-audit-trail";
import { AUDIT_LABELS } from "../messages";

interface AuditFiltersProps {
  filters: Filters;
  onChange: (key: keyof Filters, value: string) => void;
  onClear: () => void;
}

const SELECT_CLASS_NAME: string =
  "h-9 w-full rounded-md border border-gray-200 bg-white px-2 text-sm outline-none";

export function AuditFilters({
  filters,
  onChange,
  onClear,
}: AuditFiltersProps): JSX.Element {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        <label className="flex flex-col gap-1 text-xs text-gray-600">
          {AUDIT_LABELS.FILTER_ACTOR}
          <Input
            value={filters.actor_email}
            placeholder={AUDIT_LABELS.FILTER_ACTOR_PLACEHOLDER}
            onChange={(event) => onChange("actor_email", event.target.value)}
            className="h-9"
          />
        </label>

        <label className="flex flex-col gap-1 text-xs text-gray-600">
          {AUDIT_LABELS.FILTER_ACTION}
          <select
            value={filters.action}
            onChange={(event) => onChange("action", event.target.value)}
            className={SELECT_CLASS_NAME}
          >
            {AUDIT_ACTION_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-1 text-xs text-gray-600">
          {AUDIT_LABELS.FILTER_ENTITY}
          <select
            value={filters.entity_name}
            onChange={(event) => onChange("entity_name", event.target.value)}
            className={SELECT_CLASS_NAME}
          >
            {AUDIT_ENTITY_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-1 text-xs text-gray-600">
          {AUDIT_LABELS.FILTER_ENTITY_ID}
          <Input
            value={filters.entity_id}
            onChange={(event) => onChange("entity_id", event.target.value)}
            className="h-9"
          />
        </label>

      </div>

      <div className="flex justify-end">
        <Button variant="outline" className="h-9" onClick={onClear}>
          {AUDIT_LABELS.CLEAR_FILTERS}
        </Button>
      </div>
    </div>
  );
}
